import React from 'react'
import { ReactTitle } from '../utils/MetaTags'

const DPA = () => {
  return (
    <div>
      <ReactTitle title='Data Processing Agreement' />
      <section className='pane fat-pane'>
        <h1>Data Processing Agreement</h1>
        <p>
          We make it easy for Inclusivv customers to sign and submit our Data Processing Agreement (DPA). Click the link below to download the DPA and email a signed copy to
          contracts@civicdinners.com.
        </p>
        <p>
          <a href='https://civicdinners-manual-storage.s3.amazonaws.com/online-policies/Civic+Conversations+-+DPA+(20210329v1).pdf' rel='noreferrer' target='_blank'>
            Download the DPA
          </a>
        </p>
      </section>
    </div>
  )
}
export default DPA
